import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { NavIcon } from '@/layouts/components/SidebarNavItem';
export function DashboardTile({ to, icon, label, hint }) {
    return (_jsxs(Link, { to: to, className: "apolo-tile group relative flex flex-col items-center justify-center text-center overflow-hidden p-4 sm:p-8 lg:p-10 transition-all", style: {
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: 16,
            minHeight: 200,
            color: 'var(--fg)',
        }, children: [_jsx("span", { className: "apolo-tile-accent pointer-events-none absolute inset-x-0 top-0 h-[2px]", style: { background: 'var(--accent)', transform: 'scaleX(0)', transformOrigin: 'left' } }), _jsx("span", { className: "flex h-16 w-16 items-center justify-center rounded-2xl", style: {
                    background: 'rgba(var(--accent-rgb), 0.12)',
                    color: 'var(--accent)',
                }, children: _jsx(NavIcon, { name: icon, className: "h-8 w-8" }) }), _jsx("p", { className: "mt-5 text-lg sm:text-xl font-semibold leading-tight", style: { color: 'var(--fg)' }, children: label }), hint && (_jsx("p", { className: "mt-2 text-[13px] leading-snug max-w-[28ch]", style: { color: 'var(--fg-3)' }, children: hint })), _jsx("span", { className: "apolo-tile-arrow absolute right-4 top-4 transition-all", style: { color: 'var(--fg-3)' }, "aria-hidden": "true", children: _jsx("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", children: _jsx("path", { d: "M5 12h14M13 6l6 6-6 6", strokeLinecap: "round", strokeLinejoin: "round" }) }) }), _jsx("style", { children: `
        .apolo-tile:hover {
          border-color: rgba(var(--accent-rgb), 0.4);
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(var(--accent-rgb), 0.10);
        }
        .apolo-tile:hover .apolo-tile-accent {
          transform: scaleX(1);
          transition: transform 0.35s cubic-bezier(0.4,0,0.2,1);
        }
        .apolo-tile:hover .apolo-tile-arrow {
          color: var(--accent);
          transform: translateX(3px);
        }
      ` })] }));
}
//# sourceMappingURL=DashboardTile.js.map